export const ROLES_PERMISSIONS_ENDPOINTS = {
  LIST_MODULES: "/roles/modules",
  ROLES: "/roles",
  ROLE: (roleId) => `/roles/${roleId}`,
};
